var exports = {
  "i": "xa15a2ab7--928025--wrapper",
};

module.exports = exports;
